module.exports = __webpack_public_path__ + "img/arrow.2f38b641.svg";